import {registerApiType} from "./registerApiType";
import {requests} from "../../../../../@WUM/core/RestFullApi/api";

export const register = {
    getPosts: (): Promise<registerApiType[]> =>
        requests.get(`yoptimize/register/instanz/`),

}
